import { hasClass } from './helpers';
/**
 * const changeTabIndex - change tab indexes of list items for accessibility purposes
 *                      - allows the user to focus on child list items
 *
 * @param  {Array} arr         nodes to check against
 * @param  {string} tabIndexVal '0' - focus default, '-1' - prevent focus
 * @return {boolean}
 */

const changeTabIndex = function(arr, tabIndexVal) {
  [...arr].forEach(function(el) {
    if (el.nodeName === 'UL') {
      const listItems = el.childNodes;
      [...listItems].forEach(function(listItem) {
        if (listItem.nodeName === 'LI') {
          listItem.querySelector('a').setAttribute('tabindex', tabIndexVal);
        }
      });
    }
  });
};

/**
 * const arrayContainsNode - check if array contains a specific node
 *
 * @param  {Array} arr  array of nodes
 * @param  {string} node nodeName ie. 'UL'
 * @return {boolean}      - .some method will return true of return val is found, otherwise returns false
 */

const arrayContainsNode = function(arr, node) {
  const checkNode = [].some.call(arr, function(el) {
    return el.nodeName === node;
  });
  return checkNode;
};

/**
 * accessibleSubMenus - adds accessible click events
 *                    - modifies aria attributes for expanded sub menus
 *                    - modifies tabindexes for focusing with tabs
 * @return {boolean}  false for preventDefault polyfill
 */

export function accessibleSubMenus() {
  const menuItems = document.querySelectorAll(`.has-submenu`);
  [].forEach.call(menuItems, function(el, i) {
    el.querySelector('a').addEventListener('click', function(event) {
      /**
       * reset all submenus, reset all tabindexs
       */
      if (hasClass(this.parentNode, 'has-submenu')) {
        if (hasClass(this.parentNode, 'is-open')) {
          this.parentNode.classList.remove('is-open');
          this.setAttribute('aria-expanded', 'false');
          //console.log('remove');
          changeTabIndex(this.parentNode.childNodes, '-1');
        } else {
          this.parentNode.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
          //console.log('add');
          changeTabIndex(this.parentNode.childNodes, '0');
        }
      }
      event.preventDefault();
      return false;

      // menuItems.forEach(function(menuItem) {
      //   if (arrayContainsNode(menuItem.childNodes, 'UL')) {
      //     changeTabIndex(menuItem.childNodes, '-1');
      //   }
      //   menuItem.classList.remove('is-open');
      //   menuItem.querySelector('a').setAttribute('aria-expanded', 'false');
      //   menuItem.querySelector('a').setAttribute('aria-hidden', 'true');
      // });
      //
      // /**
      //  * change active tabindexes
      //  */
      // if (arrayContainsNode(this.parentNode.childNodes, 'UL')) {
      //   changeTabIndex(this.parentNode.childNodes, '0');
      //   console.log('child nodes open');
      // }
      // //console.log(this);
      // /**
      //  * add aria attributes to active submenu
      //  */
      // this.parentNode.classList.add('is-open');
      // this.setAttribute('aria-expanded', 'true');
      // this.setAttribute('aria-hidden', 'false');
      // event.preventDefault();
      // return false;
    });
  });
}

/**
 * resetDropdown - removes the dropdown styling and aria attributes when the use clicks on the element or surrounding el
 *
 * @param  {string} outsideCls surrounding element that will close the dropdown
 */

export function resetDropdown(outsideCls, dropdownId) {
  const dropdownEl = document.querySelector(dropdownId);
  const outsideEl = document.querySelector(outsideCls);
  //console.log('outsideEl', outsideEl);

  const dropdownClose = function(e) {
    // console.log('test', e.target);
    if (e.target !== dropdownEl.querySelector('a')) {
      if (hasClass(dropdownEl, 'is-open')) {
        //console.log('test', e.target);
        if (arrayContainsNode(dropdownEl.childNodes, 'UL')) {
          changeTabIndex(dropdownEl.childNodes, '-1');
        }
        dropdownEl.classList.remove('is-open');
        dropdownEl.querySelector('a').setAttribute('aria-expanded', 'false');
        dropdownEl.querySelector('a').setAttribute('aria-hidden', 'true');
      }
    }
    //}
    e.stopPropagation();
  };

  outsideEl.addEventListener('click', dropdownClose, false);
}

/**
 * ariaAttributes     - adds accessible click events
 *                    - modifies aria attributes for expanded sub menus
 * @return {boolean}  false for preventDefault polyfill
 */

export function ariaAttributes() {
  const menuItems = document.querySelectorAll(`li.has-aria`);
  [].forEach.call(menuItems, function(el, i) {
    el.querySelector('a').addEventListener('click', function(event) {
      /**
       * reset all submenus, reset all tabindexs
       */
      menuItems.forEach(function(menuItem) {
        menuItem.querySelector('a').setAttribute('aria-expanded', 'false');
        menuItem.querySelector('a').setAttribute('aria-hidden', 'true');
      });

      /**
       * add aria attributes to active submenu
       */
      this.setAttribute('aria-expanded', 'true');
      this.setAttribute('aria-hidden', 'false');
      event.preventDefault();
      return false;
    });
  });
}

/**
 * setTabIndexes - change each tabindex attr in array of list items
 *
 * @param  {array} listItems - array to be looped through
 * @param  {string} indexVal '0' for default, '-1' for closed
 */

export function setTabIndexes(listItems, indexVal) {
  [...listItems].forEach(function(listItem) {
    listItem.querySelector('a').setAttribute('tabindex', indexVal);
  });
}
